var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-5 d-flex justify-content-center align-items-center",attrs:{"id":"loading-container"}},[_c('b-spinner'),_c('span',{staticClass:"loading-label"},[_vm._v("Loading...")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }